var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRobotInfinity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 222.469,
    height: 458.124,
    viewBox: "0 0 222.469 458.124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.641,
    y1: -4.066,
    x2: 0.788,
    y2: -3.657,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2581c4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#ebdc2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209,
    stopColor: "#e7d62b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#dfc825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#d0b01a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#bc8e0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bc8e0c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12484",
    "data-name": "Group 12484",
    transform: "translate(-324 -6619.901)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_70",
    "data-name": "Ellipse 70",
    cx: 99.556,
    cy: 13.608,
    rx: 99.556,
    ry: 13.608,
    transform: "translate(335.679 7050.809)",
    fill: "#707070",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("g", {
    id: "Infinity_14",
    "data-name": "Infinity 14",
    transform: "translate(324 6619.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M371.934,416.255q-.233,3.192-.654,6.354a105.685,105.685,0,0,1-2.647,13.166,109.263,109.263,0,0,1-7.137,19.171A113.161,113.161,0,0,1,352.771,470,115.5,115.5,0,0,1,311.5,506.864q-4.641,2.454-9.544,4.462a108.428,108.428,0,0,1-80.455.775c-.736-.289-1.47-.586-2.2-.891q-3.711-1.535-7.254-3.338c-.738-.376-1.468-.75-2.187-1.142-.117-.061-.234-.13-.351-.191a113.952,113.952,0,0,1-41.8-39.374c-.319-.51-.638-1.021-.958-1.54a117.417,117.417,0,0,1-7.143-13.567c-.255-.558-.5-1.115-.739-1.68a115.787,115.787,0,0,1-5.49-15.968,108.852,108.852,0,0,1-2.719-13.661,104.04,104.04,0,0,1-.721-20.665,98.17,98.17,0,0,1,4.188-22.621c5.353-17.37,14.9-31.5,24.563-42.288v-.009A142.155,142.155,0,0,1,191.511,322.6a126.216,126.216,0,0,1,17.606-12.929l.106-.018c.291-.066.584-.132.874-.188a245.569,245.569,0,0,1,93.244-1.54q2.976.517,5.775,1.082c.009,0,.016.01.025.01.669.127,1.338.263,1.989.4.1.025.2.041.3.065q2.467,1.407,4.85,2.91c.275.168.54.344.806.52a124.658,124.658,0,0,1,27.946,24.449v.009a120.028,120.028,0,0,1,7.565,9.927c1.312,1.922,2.57,3.884,3.755,5.874q1.2,1.979,2.3,4a112.227,112.227,0,0,1,9.532,23.281,103.753,103.753,0,0,1,2.684,12.111,102.514,102.514,0,0,1,1.066,23.691Z",
    transform: "translate(-149.725 -72.503)",
    fill: "#e9f0fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M325.342,314.473a2.634,2.634,0,0,1-.63,1.607c-1.057,1.384-3.474,2.678-6.975,3.823-.018.007-.044.014-.062.022a83.856,83.856,0,0,1-12.28,2.741l-1.012.161a233.289,233.289,0,0,1-34.885,2.147c-5.555-.03-10.924-.231-15.988-.565H253.5c-16.672-1.085-30.054-3.634-36.136-6.825-.268-.141-.518-.29-.76-.429a5.54,5.54,0,0,1-2.694-2.77,2.284,2.284,0,0,1-.108-.678,2.624,2.624,0,0,1,.075-.56,2.362,2.362,0,0,1,.223-.549,4.768,4.768,0,0,1,1.455-1.581c.174-.127.357-.252.541-.387a.273.273,0,0,0,.064-.039,17.667,17.667,0,0,1,2.431-1.258c8.693-3.75,28.289-6.28,51.057-6.126,18.508.122,34.9,2,45.026,4.776a.028.028,0,0,1,.025.01c1.04.285,2.01.581,2.91.881.009,0,.016.01.025.01,4.049,1.365,6.668,2.9,7.454,4.535a2.4,2.4,0,0,1,.254,1.053Z",
    transform: "translate(-158.219 -72.371)",
    fill: "#aeb7c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M198.91,354.675A204.646,204.646,0,0,0,174.722,398.4a36.8,36.8,0,0,1-19.92-16.2c5.353-17.37,14.9-31.5,24.563-42.288a32.121,32.121,0,0,0,19.544,14.771Z",
    transform: "translate(-150.398 -77.237)",
    fill: "#aeb7c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M395.01,385.522a36.683,36.683,0,0,1-20.168,15.134,203.892,203.892,0,0,0-22.747-44.482,32.392,32.392,0,0,0,11.857-5.407,32.037,32.037,0,0,0,7.9-8.33,120.281,120.281,0,0,1,7.566,9.927c1.312,1.922,2.57,3.884,3.755,5.874q1.2,1.979,2.3,4a112.237,112.237,0,0,1,9.532,23.281Z",
    transform: "translate(-176.551 -77.572)",
    fill: "#aeb7c5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 36.43,
    height: 26.021,
    rx: 6.711,
    transform: "translate(92.878 278.879) rotate(0.36)",
    fill: "#2eb3bd",
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 9.162,
    height: 80.511,
    transform: "matrix(1, 0.011, -0.011, 1, 106.514, 304.964)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M371.422,440.42a105.688,105.688,0,0,1-2.647,13.166,181.514,181.514,0,0,1-28.77,15.734c-.081.037-.161.067-.242.1-40.922,17.684-77.244,15.316-91.6,14.21A215.079,215.079,0,0,1,170.537,461.7c-6.572-3.27-12.274-6.539-17.009-9.476a108.861,108.861,0,0,1-2.719-13.661c2.848,1.86,6.134,3.909,9.822,6.047a216.068,216.068,0,0,0,76.923,27.052c6.4.893,12.448,1.411,18.011,1.695q4.836.234,9.158.241a177.566,177.566,0,0,0,24.9-1.491,191.9,191.9,0,0,0,53.007-15.586c5.154-2.346,10.482-5.037,15.907-8.112,5.035-2.851,9.358-5.606,12.888-7.985Z",
    transform: "translate(-149.869 -90.314)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M220.82,533.806q-3.711-1.535-7.253-3.338c-.738-.376-1.468-.75-2.187-1.142a103.416,103.416,0,0,0,1.751-14.841,10.784,10.784,0,0,0-1.685-6.95,10.559,10.559,0,0,0-4.071-3.219,9.379,9.379,0,0,0-2.132-.581,199.327,199.327,0,0,1-36.015-13.974c-.319-.51-.638-1.021-.958-1.54a117.431,117.431,0,0,1-7.143-13.567c.25.148.517.307.775.456a222.71,222.71,0,0,0,51.475,21.676,11.756,11.756,0,0,1,2.379.651A12.846,12.846,0,0,1,224,510.379,105.189,105.189,0,0,1,220.82,533.8Z",
    transform: "translate(-151.236 -95.099)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M384.362,477.987a113.186,113.186,0,0,1-8.725,15.054,199.747,199.747,0,0,1-34.525,12.6,9.165,9.165,0,0,0-2.145.557,10.64,10.64,0,0,0-4.125,3.143,10.828,10.828,0,0,0-1.783,6.933A104.591,104.591,0,0,0,334.37,529.9q-4.64,2.454-9.544,4.462A104.834,104.834,0,0,1,322.254,512a12.852,12.852,0,0,1,8.439-12.814,11.79,11.79,0,0,1,2.392-.608,223.054,223.054,0,0,0,51.275-20.591Z",
    transform: "translate(-172.593 -95.541)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M311.834,307.792c-11.352-.444-27.751,2.71-40.046,9.842-3.088,1.793-9.23,5.755-18.28,6.775H253.5c-4.236.474-7.323.109-11.942-.47-7.549-.95-18.59-3.294-24.195-6.355-.268-.141-.518-.29-.76-.429a5.915,5.915,0,0,1-2.694-2.77,2.284,2.284,0,0,1-.108-.678,2.623,2.623,0,0,1,.076-.56,2.755,2.755,0,0,1,.223-.549,5.263,5.263,0,0,1,1.455-1.581c.174-.127.357-.252.541-.387a.272.272,0,0,0,.064-.039c.5-.347,1.017-.709,1.556-1.07.292-.066.584-.132.874-.188,8.693-3.75,28.289-6.28,51.057-6.126,18.508.122,34.9,2,45.026,4.776-.907-.092-1.849-.16-2.839-.189Z",
    transform: "translate(-158.219 -72.371)",
    fill: "#232952",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M390.988,417.507q-.233,3.192-.654,6.354a105.69,105.69,0,0,1-2.647,13.166,109.269,109.269,0,0,1-7.137,19.171,113.177,113.177,0,0,1-8.725,15.055,115.494,115.494,0,0,1-41.267,36.863q-4.641,2.454-9.545,4.462a107.989,107.989,0,0,1-27.545,7.282,155.741,155.741,0,0,0,21.571-12.919c12.963-9.249,28.936-20.653,39.005-41.994a85.831,85.831,0,0,0,4.629-12.083,90.068,90.068,0,0,0,2.863-12.907,129.522,129.522,0,0,0,1.193-14.577c1.055-28.81-10.506-52.184-10.506-52.184-4.056-8.676-11.357-23.837-27.688-36.416A85.8,85.8,0,0,0,304.767,325.4c1.826-.192,16.557-1.753,19.052-2.59a34.887,34.887,0,0,0,4.414-1.505c.018-.008.044-.014.063-.022a37.231,37.231,0,0,0,6.975-3.823,6.109,6.109,0,0,0,.377-2.66,3.472,3.472,0,0,0-.316-1.162,124.986,124.986,0,0,1,28.752,24.968v.009a120.07,120.07,0,0,1,7.565,9.927c1.312,1.922,2.57,3.884,3.755,5.874q1.2,1.979,2.3,4a112.231,112.231,0,0,1,9.532,23.281,103.744,103.744,0,0,1,2.684,12.111,102.507,102.507,0,0,1,1.066,23.691Z",
    transform: "translate(-168.78 -73.755)",
    fill: "#232952",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M209.516,509.352a113.948,113.948,0,0,1-41.8-39.374c-.319-.51-.638-1.021-.958-1.54a117.427,117.427,0,0,1-7.143-13.567c-.255-.558-.5-1.115-.739-1.68a115.787,115.787,0,0,1-5.49-15.968,108.844,108.844,0,0,1-2.719-13.661,104.035,104.035,0,0,1-.721-20.665,98.164,98.164,0,0,1,4.188-22.621c5.353-17.371,14.9-31.5,24.563-42.289v-.009a142.191,142.191,0,0,1,12.814-12.565c-2.186,3.268-4.578,6.973-7.077,11.069-7.555,12.383-16.078,26.338-21.211,41.751-.814,2.454-8.841,27.4-4.386,54.952,6.269,38.829,34.317,64.269,50.68,76.167Z",
    transform: "translate(-149.725 -75.316)",
    fill: "#fff",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M337.379,315.4c-.522,1.675-1.872,2.89-3.8,3.916a.171.171,0,0,0-.055.031,52,52,0,0,1-8.229,3.01,62.649,62.649,0,0,1-20.621,2.733h-.017l-.052-.005a120.985,120.985,0,0,0,12.228-3.345c8.742-2.886,13.148-4.382,14.458-7.453a6.92,6.92,0,0,0,.428-3.718c-.018-.115-.035-.238-.061-.361.1.025.2.041.3.065q2.467,1.406,4.85,2.91c.275.168.54.344.806.52a5.321,5.321,0,0,1-.237,1.7Z",
    transform: "translate(-170.256 -73.3)",
    fill: "#fff",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M328.686,227.865a11.716,11.716,0,0,1-5.2,3.092,145.012,145.012,0,0,1-57.731,10.11q-1.784-.052-3.511-.152a144.459,144.459,0,0,1-36.033-6.695c-1.691-.549-3.3-1.092-4.8-1.637A11.649,11.649,0,0,1,216.2,229.7a11.424,11.424,0,0,1-3.506-8.1L209.985,56.045a11.957,11.957,0,0,1,3.243-8.209,11.577,11.577,0,0,1,3.151-2.3,11.842,11.842,0,0,1,3.2-1.054h.009a193.412,193.412,0,0,1,100.1-1.544c.1.016.223.043.351.069a11.692,11.692,0,0,1,3.869,1.569A10.664,10.664,0,0,1,325.714,46a12.013,12.013,0,0,1,3.515,8.1l2.7,165.552a12.087,12.087,0,0,1-3.243,8.217Z",
    transform: "translate(-157.713 -37.096)",
    fill: "#e9f0fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M324.063,199.816c-2.653.955-5.082,1.943-7.266,2.906a9.465,9.465,0,0,0-4.372,2.943,11.982,11.982,0,0,0-2.439,4.71,13.359,13.359,0,0,0-.45,3.429l-.037,5.886a102.569,102.569,0,0,1-58.542,4.537,106.6,106.6,0,0,1-12.215-3.4l-.574-6.921a13.366,13.366,0,0,0-.719-3.384,11.97,11.97,0,0,0-2.794-4.509,9.339,9.339,0,0,0-4.586-2.6c-1.967-.7-4.126-1.4-6.46-2.062l-2.566-156.87h.009a193.3,193.3,0,0,1,92.6-3.264c2.656.55,5.153,1.132,7.494,1.72.1.016.223.043.351.069Z",
    transform: "translate(-159.179 -37.096)",
    fill: "#353f44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M336.672,229.007a11.717,11.717,0,0,1-5.2,3.092,145.015,145.015,0,0,1-57.731,10.11q-1.784-.052-3.511-.152c26.561-4.527,45.933-9.465,53.179-13.182a18,18,0,0,0,8.279-7.511,17.5,17.5,0,0,0,1.554-10.715q-.712-66.338-1.155-132.667-.116-16.133-.2-32.264a10.672,10.672,0,0,1,1.81,1.419,12.013,12.013,0,0,1,3.515,8.1l2.7,165.552A12.086,12.086,0,0,1,336.672,229.007Z",
    transform: "translate(-165.699 -38.239)",
    fill: "#232952",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M328.634,200.446c-2.653.955-5.081,1.943-7.266,2.906A9.466,9.466,0,0,0,317,206.295a11.983,11.983,0,0,0-2.439,4.71,13.356,13.356,0,0,0-.45,3.429l-.037,5.886a102.568,102.568,0,0,1-58.542,4.537,221.075,221.075,0,0,0,40.891-11.65,38.128,38.128,0,0,0,5.985-2.652c19.06-11.4,17.095-43.512,16.178-94.684-.305-17.174-.6-42.522-.356-74.023,2.656.55,5.154,1.132,7.494,1.72.1.016.223.042.351.069l2.562,156.809Z",
    transform: "translate(-163.75 -37.726)",
    fill: "#15192f",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M226.191,162.31q-.388-55.691-.776-111.383a133.169,133.169,0,0,1,13.41-3.661,136.241,136.241,0,0,1,43.842-2.218c-5.9,1.175-14.616,3.086-25.116,6.073-9.6,2.732-11.548,3.759-12.829,4.576-10.963,7-12.1,23.543-12.823,33.585-1.61,22.39-3.546,45.894-5.707,73.029Z",
    transform: "translate(-159.759 -38.039)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M226.211,235.509c-1.691-.549-3.3-1.092-4.8-1.637a11.649,11.649,0,0,1-5.217-2.885,11.424,11.424,0,0,1-3.506-8.1L209.985,57.335a11.957,11.957,0,0,1,3.243-8.209,11.577,11.577,0,0,1,3.151-2.3c-.644,2.623-1.3,5.723-1.862,9.214a114.951,114.951,0,0,0-1.429,19.613c.282,32.427.422,48.65.7,70.013.3,22.748,3.2,45.477,2.372,68.212a25.24,25.24,0,0,0,.952,8.184A28.356,28.356,0,0,0,226.211,235.509Z",
    transform: "translate(-157.713 -38.386)",
    fill: "#fff",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M318.033,195.393c-2.306.89-4.417,1.809-6.316,2.706a8.277,8.277,0,0,0-3.8,2.728,11.378,11.378,0,0,0-2.135,4.348,13.043,13.043,0,0,0-.4,3.16l-.056,5.421a85.937,85.937,0,0,1-35.638,6.395,84.515,84.515,0,0,1-15.178-1.987,87.634,87.634,0,0,1-10.586-3.087l-.471-6.373a12.931,12.931,0,0,0-.611-3.113,10.986,10.986,0,0,0-2.407-4.142,7.885,7.885,0,0,0-3.969-2.372c-1.7-.637-3.574-1.27-5.6-1.875L229.248,52.721h.008a159.749,159.749,0,0,1,40.011-6.869,157.732,157.732,0,0,1,40.357,3.5c2.3.5,4.467,1.023,6.5,1.555.089.015.193.038.3.062l1.61,144.424Z",
    transform: "translate(-160.267 -38.238)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 19.441,
    height: 19.441,
    rx: 9.037,
    transform: "translate(80.186 82.153)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 19.441,
    height: 19.441,
    rx: 9.037,
    transform: "translate(104.781 82.695)",
    opacity: 0.61,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 19.441,
    height: 19.441,
    rx: 9.037,
    transform: "translate(130.017 82.695)",
    opacity: 0.33,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M266.829,378.807a5.589,5.589,0,0,1-4.505-6.235,5.575,5.575,0,0,1,2.275-3.823,5.444,5.444,0,0,1,2.958-.865c3.3-.113,5.71,2.334,6.235,2.867a28.69,28.69,0,0,1,1.86,2.2c.669.862.888,1.229,1.268,1.742a10.1,10.1,0,0,0,3.88,3.612,6.014,6.014,0,0,0,4.368.318,5.88,5.88,0,0,0,3.291-2.94,5.456,5.456,0,0,0,.514-3.791,5.2,5.2,0,0,0-1.092-2.056,5.772,5.772,0,0,0-2.155-1.608,7.277,7.277,0,0,0-6.338.975,13.006,13.006,0,0,0-1.733,1.352c-.072.068-.128.123-.168.162a14.563,14.563,0,0,0-1.837,2.235c-.631.9-.737,1.2-1.132,1.8a9.2,9.2,0,0,1-3.823,3.5,6.213,6.213,0,0,1-3.868.547Z",
    transform: "translate(-164.646 -80.945)",
    fill: "none",
    stroke: "#139093",
    strokeWidth: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotInfinity);
export default __webpack_public_path__ + "static/media/robot-infinity.a1b68ec93ac3d0e0a46bac48f88ecb56.svg";
export { ForwardRef as ReactComponent };